import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropzone } from 'dropzone';

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';

// ========== SCSS ==========
import '../scss/registry.scss';

export class FileRegistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      name: '',
      directory_id: null,
      source: '',
      type: '',
      is_video: false
    };
  }

  handleChange(e) {
    const value = e.target.value;

    if (this.state.type == 'embed_video' && window.normalizeString(value).includes('onedrive')) {
      window.alert('ATENÇÃO: Vídeos incorporados do Onedrive não são mais suportados por diversos navegadores modernos!');
    }

    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  handleCheckBoxChange(e) {
    const checked = e.target.checked;

    let type = '';
    if (e.target.name == 'is_video' && checked)
      type = 'embed_video';

    this.setState({
      ...this.state,
      [e.target.name]: checked,
      type: type
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    let response = await window.doRequest('POST', {
      action: 'saveFile',
      token: sessionStorage.getItem('token'),
      name: this.state.name,
      source: this.state.source,
      directory_id: this.state.directory_id,
      type: this.state.type
    });

    if (response.status) {

      this.props.history.push('/directory/' + this.state.directory_id);

    } else
        window.alert(response.message);
  }

  getTypeLabel(fileType) {
    switch (fileType) {
      case 'image/png':
        return 'photo';
      case 'image/jpg':
        return 'photo';
      case 'image/jpeg':
        return 'photo';
      case 'image/gif':
        return 'photo';
      case 'image/gif':
        return 'photo';
      case 'application/pdf':
        return 'pdf';
      default:
        return null;
    }
  }

  startDropzone() {
    const dropzone = new Dropzone('#dropzone', {
      url: (window.utils.site_url + '?action=uploadFile&token=' + sessionStorage.getItem('token')),
      headers: {
        'Cache-Control': null,
        'X-Requested-With': null,
      },
      dictDefaultMessage: 'Solte um arquivo aqui'
    });

    let saveFileInfo = (content) => {
      this.setState({
        source: content.path,
        type: this.getTypeLabel(content.type)
      })
    }

    dropzone.on('success', function (file, response) {

      if (response.status)
        saveFileInfo(response.content);
      else
          window.alert(response.message);

    });
  }

  async verifyIfHasPrivileges(directoryId) {
    let response = await window.doRequest('GET', {
      action: 'hasPrivileges',
      token: sessionStorage.getItem('token'),
      id: directoryId,
      privilege_type: 'edit'
    });

    if (response.status) {
      this.setState({
        loading: false,
        directory_id: directoryId
      })

      this.startDropzone();

    } else
      window.alert(response.message);
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    let url = window.location;
    let directoryId = /[^/]*$/.exec(url)[0];

    this.verifyIfHasPrivileges(directoryId);
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="registry">
          <div className="container">
            {
              (this.state.loading)
                ? <Loader />
                : <div className="file-registry">
                    <h1 className="title">Registro de arquivo</h1>
                    {
                      (this.state.directory_id != null)
                        ? <div className="back-btn-container">
                            <button className="back-btn" onClick={(e) => {
                              this.props.history.push('/directory/' + this.state.directory_id)
                            }}>
                              Voltar
                            </button>
                          </div>
                        : null
                    }
                    <p>Preencha os dados abaixo.</p>
                    <form onSubmit={(e) => { this.formSubmit(e) }}>

                      <input
                        type="text"
                        placeholder="Nome do arquivo"
                        name="name"
                        value={this.state.name}
                        onChange={(e) => {this.handleChange(e)}}
                        required>
                      </input>

                      <div className="video-input-controller">
                        <label>Vídeo incorporado?</label>
                        <input type="checkbox" name="is_video" checked={this.state.is_video} onChange={(e) => {this.handleCheckBoxChange(e)}}/>
                      </div>

                      <div className={'dropzone' + (!this.state.is_video ? ' active' : '')} id="dropzone"></div>

                      <div className={'video-input-container' + (this.state.is_video ? ' active' : '')}>
                        <p>
                          Copie o código de incorporação do&nbsp;
                          <a
                            href="https://www.colby.edu/acits/2020/01/30/how-to-embed-a-video-from-google-drive/"
                            target="_blank"
                            rel="noopener"
                            title="Como obter o código de incorporação?"
                          >
                            <strong>Google Drive</strong>
                          </a> e cole abaixo:
                        </p>
                        <textarea
                          placeholder="Código de incorporação"
                          name="source"
                          value={this.state.source}
                          onChange={(e) => {this.handleChange(e)}}
                          required
                        ></textarea>
                      </div>

                      <div className="btn-container">
                        <button className="btn filled" type="submit">Salvar</button>
                      </div>

                    </form>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default FileRegistry
